var AppCtrl = function () {

};

angular.module('webApp.controllers').controller('AppCtrl', AppCtrl);
